export const getEditModalId = (userId?: string) => `${userId}-edit-vat-rate-modal`
